<template>
  <div class="home">
   <h3>Hello World</h3>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'HomeView',
  components: {
  }
}
</script>
